export default "__VITE_ASSET__PGp_$dKj__"